export default __webpack_public_path__ + "static/media/higher_icon_wallet_reversed.cefa21f5.svg";